export default "/images/831e03d6cbca1f5c9f62768cb3714739.avif";